import { observable, action, computed } from 'mobx'
import moment from 'moment'

class DatesStore {

    @observable dates
    @observable currentStartOfWeek
    @observable currentWeekNumber
    @observable today

    constructor() {
        this.dates = null
        this.currentStartOfWeek = null
        this.currentWeekNumber = null
        this.today = moment().format("YYYY-MM-DD");
        this.tomorrow = moment().add(1, 'days').format("YYYY-MM-DD");
        this.currentTime = moment().format("HH:mm:ss");
    }

    @computed get isDates() {
        return this.dates ? true : false
    }

    @action setDates = (dates, currentStartOfWeek, currentWeekNumber) => {
        this.dates = dates
        this.currentStartOfWeek = currentStartOfWeek
        this.currentWeekNumber = currentWeekNumber + 1
    }

    getCurrentWeek() {

        let currentWeekNumber = moment().week()

        let startOfWeek = moment().startOf('week').add(2, 'd')
        let endOfWeek = moment().endOf('week').add(2, 'd')

        this.getDates(startOfWeek, endOfWeek, currentWeekNumber)
    }

    getNextMonth() {

        const currentStartOfWeek = this.currentStartOfWeek.add(1, 'M')

        const startOfMonth = currentStartOfWeek.startOf('month')
        const endOfMonth = currentStartOfWeek.endOf('month')

        const currentWeekNumber = moment(startOfMonth).week()

        this.getDates(startOfMonth, endOfMonth, currentWeekNumber)
    }

    getPreviousMonth() {

        const currentStartOfWeek = this.currentStartOfWeek.subtract(1, 'M')

        const startOfMonth = currentStartOfWeek.startOf('month')
        const endOfMonth = currentStartOfWeek.endOf('month')


        const currentWeekNumber = moment(startOfMonth).week()

        this.getDates(startOfMonth, endOfMonth, currentWeekNumber)
    }

    getNextWeek() {

        const currentStartOfWeek = this.currentStartOfWeek

        const startOfWeek = currentStartOfWeek.clone().add(7, 'd')
        const endOfWeek = currentStartOfWeek.clone().add(13, 'd')

        const currentWeekNumber = moment(startOfWeek).week()

        this.getDates(startOfWeek, endOfWeek, currentWeekNumber)
    }

    getPreviousWeek() {

        const currentStartOfWeek = this.currentStartOfWeek

        const startOfWeek = currentStartOfWeek.clone().subtract(7, 'd')
        const endOfWeek = currentStartOfWeek.clone().subtract(1, 'd')

        const currentWeekNumber = moment(startOfWeek).week()

        this.getDates(startOfWeek, endOfWeek, currentWeekNumber)
    }

    getDates(startOfWeek, endOfWeek, currentWeekNumber) {

        let dates = [];
        let day = startOfWeek

        while (day <= endOfWeek) {
            dates.push(day.toDate())
            day = day.clone().add(1, 'd')
        }

        this.setDates(dates, startOfWeek, currentWeekNumber)
    }
}

const store = new DatesStore()
export default store


// WEBPACK FOOTER //
// /src/stores/DatesStore.js